import { SkipOrArgs } from '@common/types/queryState';
import { useSelectedProductionId } from '@features/productions';
import { GetCfdAPIArgs } from '../types';
import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useApiQuery } from '@common/hooks';
import { useGetCustomFieldDescriptionsQuery } from '../api';

export const useCustomFieldDescriptions = () => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetCfdAPIArgs> = useMemo(() => {
        if (!productionId) return skipToken;
        return { productionId };
    }, [productionId]);

    const { data: rawCfd, ...queryResult } = useApiQuery(
        useGetCustomFieldDescriptionsQuery,
        queryArgs,
    );

    const data = useMemo(() => {
        if (!rawCfd) return { cfdRecord: {}, cfdArray: [] };
        const cfdRecord = rawCfd;
        const cfdArray = Object.values(cfdRecord).sort(
            (a, b) => (a.order ?? 99) - (b.order ?? 99),
        );

        return { cfdRecord, cfdArray };
    }, [rawCfd]);

    return { data, ...queryResult };
};
